import { render, staticRenderFns } from "./ComplexManager.vue?vue&type=template&id=b155906c&scoped=true&"
import script from "./ComplexManager.vue?vue&type=script&lang=js&"
export * from "./ComplexManager.vue?vue&type=script&lang=js&"
import style0 from "./ComplexManager.vue?vue&type=style&index=0&id=b155906c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b155906c",
  null
  
)

export default component.exports